@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import ai.wagemix.components.layouts.AppShellLayout as _ai_wagemix_components_layouts_AppShellLayout
import ai.wagemix.components.layouts.AuthLayout as _ai_wagemix_components_layouts_AuthLayout
import ai.wagemix.components.layouts.MarkdownLayout as _ai_wagemix_components_layouts_MarkdownLayout
import ai.wagemix.components.layouts.MarketingLayout as _ai_wagemix_components_layouts_MarketingLayout
import ai.wagemix.pages.AccountPage as _ai_wagemix_pages_AccountPage
import ai.wagemix.pages.AuthActionPage as _ai_wagemix_pages_AuthActionPage
import ai.wagemix.pages.ForgotPasswordPage as _ai_wagemix_pages_ForgotPasswordPage
import ai.wagemix.pages.HomePage as _ai_wagemix_pages_HomePage
import ai.wagemix.pages.JobDescriptionsPage as _ai_wagemix_pages_JobDescriptionsPage
import ai.wagemix.pages.LoginPage as _ai_wagemix_pages_LoginPage
import ai.wagemix.pages.LogoutPage as _ai_wagemix_pages_LogoutPage
import ai.wagemix.pages.MethodologyPage as _ai_wagemix_pages_MethodologyPage
import ai.wagemix.pages.MixPage as _ai_wagemix_pages_MixPage
import ai.wagemix.pages.MixesPage as _ai_wagemix_pages_MixesPage
import ai.wagemix.pages.PaymentResultPage as _ai_wagemix_pages_PaymentResultPage
import ai.wagemix.pages.PricingPage as _ai_wagemix_pages_PricingPage
import ai.wagemix.pages.Privacy_policyPage as _ai_wagemix_pages_Privacy_policyPage
import ai.wagemix.pages.RegisterPage as _ai_wagemix_pages_RegisterPage
import ai.wagemix.pages.SharedLinksPage as _ai_wagemix_pages_SharedLinksPage
import ai.wagemix.pages.SharedMixPage as _ai_wagemix_pages_SharedMixPage
import ai.wagemix.pages.StoredMixPage as _ai_wagemix_pages_StoredMixPage
import ai.wagemix.pages.TermsPage as _ai_wagemix_pages_TermsPage
import ai.wagemix.pages.dev.ComponentsGalleryPage as _ai_wagemix_pages_dev_ComponentsGalleryPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Wagemix AI", "SITE_ENV" to "prod", "APP_VERSION" to "1.0.0+f961332", "API_URL" to "https://api.wagemix.ai", "ANALYTICS_CLIENT_ID" to "8b304b87-c654-4783-b09d-0ba1802f3902", "SITE_URL" to "https://www.wagemix.ai"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx, pageMethod -> 
            _ai_wagemix_components_layouts_AppShellLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "ai.wagemix.components.layouts.AuthLayout",
        ) { pageCtx, pageMethod -> 
            _ai_wagemix_components_layouts_AuthLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "ai.wagemix.components.layouts.MarkdownLayout",
        ) { pageCtx, pageMethod -> 
            _ai_wagemix_components_layouts_MarkdownLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "ai.wagemix.components.layouts.MarketingLayout",
        ) { pageCtx, pageMethod -> 
            _ai_wagemix_components_layouts_MarketingLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "ai.wagemix.components.layouts.MarketingLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_HomePage(pageCtx)
        }
        ctx.router.register(
            "/account",
            layoutId = "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_AccountPage(pageCtx)
        }
        ctx.router.register(
            "/auth-action",
            layoutId = "ai.wagemix.components.layouts.AuthLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_AuthActionPage(pageCtx)
        }
        ctx.router.register(
            "/dev/components",
        ) { pageCtx -> 
            _ai_wagemix_pages_dev_ComponentsGalleryPage()
        }
        ctx.router.register(
            "/forgot-password",
            layoutId = "ai.wagemix.components.layouts.AuthLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_ForgotPasswordPage(pageCtx)
        }
        ctx.router.register(
            "/job-descriptions",
            layoutId = "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_JobDescriptionsPage(pageCtx)
        }
        ctx.router.register(
            "/login",
            layoutId = "ai.wagemix.components.layouts.AuthLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_LoginPage(pageCtx)
        }
        ctx.router.register(
            "/logout",
        ) { pageCtx -> 
            _ai_wagemix_pages_LogoutPage(pageCtx)
        }
        ctx.router.register(
            "/methodology",
            layoutId = "ai.wagemix.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                ai.wagemix.pages.initMethodologyPage(ctx)
            },
        ) { pageCtx -> 
            _ai_wagemix_pages_MethodologyPage()
        }
        ctx.router.register(
            "/mix",
            layoutId = "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_MixPage(pageCtx)
        }
        ctx.router.register(
            "/mix/{mixId}",
            layoutId = "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_StoredMixPage(pageCtx)
        }
        ctx.router.register(
            "/mixes",
            layoutId = "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_MixesPage(pageCtx)
        }
        ctx.router.register(
            "/payment-result",
            layoutId = "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_PaymentResultPage(pageCtx)
        }
        ctx.router.register(
            "/pricing",
            layoutId = "ai.wagemix.components.layouts.MarketingLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_PricingPage(pageCtx)
        }
        ctx.router.register(
            "/privacy-policy",
            layoutId = "ai.wagemix.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                ai.wagemix.pages.initPrivacy_policyPage(ctx)
            },
        ) { pageCtx -> 
            _ai_wagemix_pages_Privacy_policyPage()
        }
        ctx.router.register(
            "/register",
            layoutId = "ai.wagemix.components.layouts.AuthLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_RegisterPage(pageCtx)
        }
        ctx.router.register(
            "/s/mix/{id}",
        ) { pageCtx -> 
            _ai_wagemix_pages_SharedMixPage(pageCtx)
        }
        ctx.router.register(
            "/shared-links",
            layoutId = "ai.wagemix.components.layouts.AppShellLayout",
        ) { pageCtx -> 
            _ai_wagemix_pages_SharedLinksPage(pageCtx)
        }
        ctx.router.register(
            "/terms",
            layoutId = "ai.wagemix.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                ai.wagemix.pages.initTermsPage(ctx)
            },
        ) { pageCtx -> 
            _ai_wagemix_pages_TermsPage()
        }

        ai.wagemix.initWagemixAnalytics(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("auth-brand-panel", ai.wagemix.components.layouts.AuthBrandPanelStyle)
        ctx.theme.registerStyle("auth-form-side", ai.wagemix.components.layouts.AuthFormSideStyle)
        ctx.theme.registerStyle("auth-form", ai.wagemix.components.layouts.AuthFormStyle)
        ctx.theme.registerStyle("auth-brand-preview", ai.wagemix.components.layouts.AuthBrandPreviewStyle)
        ctx.theme.registerStyle("auth-brand-copy", ai.wagemix.components.layouts.AuthBrandCopyStyle)
        ctx.theme.registerStyle("markdown", ai.wagemix.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("hero", ai.wagemix.pages.HeroStyle)
        ctx.theme.registerStyle("three-up", ai.wagemix.pages.ThreeUpStyle)
        ctx.theme.registerStyle("four-up", ai.wagemix.pages.FourUpStyle)
        ctx.theme.registerStyle("wm-occupation-picker-tree", ai.wagemix.web.screens.picker.WMOccupationPickerTreeStyle)
        ctx.theme.registerStyle("wm-auth-link", ai.wagemix.web.screens.auth.WMAuthLinkStyle)
        ctx.theme.registerStyle("wm-drawer-scrim", ai.wagemix.web.screens.appshell.WMDrawerScrimStyle)
        ctx.theme.registerStyle("wm-drawer-scrim-open", ai.wagemix.web.screens.appshell.WMDrawerScrimOpenStyle)
        ctx.theme.registerStyle("wm-drawer", ai.wagemix.web.screens.appshell.WMDrawerStyle)
        ctx.theme.registerStyle("wm-drawer-open", ai.wagemix.web.screens.appshell.WMDrawerOpenStyle)
        ctx.theme.registerStyle("wm-no-transition", ai.wagemix.web.screens.appshell.WMNoTransitionStyle)
        ctx.theme.registerStyle("wm-drawer-close", ai.wagemix.web.screens.appshell.WMDrawerCloseStyle)
        ctx.theme.registerStyle("wm-app-main", ai.wagemix.web.screens.appshell.WMAppMainStyle)
        ctx.theme.registerStyle("wm-ellipsis", ai.wagemix.web.screens.appshell.WMEllipsisStyle)
        ctx.theme.registerStyle("wm-shared-stat-tiles", ai.wagemix.web.screens.sharedmix.WMSharedStatTilesStyle)
        ctx.theme.registerStyle("wm-builder-columns", ai.wagemix.web.screens.mixbuilder.WMBuilderColumnsStyle)
        ctx.theme.registerStyle("wm-reevaluating", ai.wagemix.web.screens.mixbuilder.WMReevaluatingStyle)
        ctx.theme.registerStyle("wm-builder-left-column", ai.wagemix.web.screens.mixbuilder.WMBuilderLeftColumnStyle)
        ctx.theme.registerStyle("wm-stat-tiles", ai.wagemix.web.screens.mixbuilder.WMStatTilesStyle)
        ctx.theme.registerStyle("wm-account-columns", ai.wagemix.web.screens.account.WMAccountColumnsStyle)
        ctx.theme.registerStyle("wm-mix-grid", ai.wagemix.web.screens.mixes.WMMixGridStyle)
        ctx.theme.registerStyle("wm-plan-grid", ai.wagemix.web.screens.pricing.WMPlanGridStyle)
        ctx.theme.registerStyle("wm-step-number", ai.wagemix.web.components.WMStepNumberStyle)
        ctx.theme.registerStyle("wm-plan-card-highlighted", ai.wagemix.web.components.WMPlanCardHighlightedStyle)
        ctx.theme.registerStyle("wm-input-with-trailing-button", ai.wagemix.web.components.WMInputWithTrailingButtonStyle)
        ctx.theme.registerStyle("wm-input-with-icon", ai.wagemix.web.components.WMInputWithIconStyle)
        ctx.theme.registerStyle("wm-select", ai.wagemix.web.components.WMSelectStyle)
        ctx.theme.registerStyle("wm-fact-carousel", ai.wagemix.web.components.WMFactCarouselStyle)
        ctx.theme.registerStyle("wm-fact-carousel-track", ai.wagemix.web.components.WMFactCarouselTrackStyle)
        ctx.theme.registerStyle("wm-fact-carousel-slide", ai.wagemix.web.components.WMFactCarouselSlideStyle)
        ctx.theme.registerStyle("wm-notice", ai.wagemix.web.components.WMNoticeStyle)
        ctx.theme.registerStyle("wm-combo-box-input", ai.wagemix.web.components.WMComboBoxInputStyle)
        ctx.theme.registerStyle("wm-combo-box-list", ai.wagemix.web.components.WMComboBoxListStyle)
        ctx.theme.registerStyle("wm-combo-box-option", ai.wagemix.web.components.WMComboBoxOptionStyle)
        ctx.theme.registerStyle("wm-segmented-control", ai.wagemix.web.components.WMSegmentedControlStyle)
        ctx.theme.registerStyle("wm-segment", ai.wagemix.web.components.WMSegmentStyle)
        ctx.theme.registerStyle("wm-segment-selected", ai.wagemix.web.components.WMSegmentSelectedStyle)
        ctx.theme.registerStyle("wm-slider", ai.wagemix.web.components.WMSliderStyle)
        ctx.theme.registerStyle("wm-dialog", ai.wagemix.web.components.WMDialogStyle)
        ctx.theme.registerStyle("wm-dialog-body", ai.wagemix.web.components.WMDialogBodyStyle)
        ctx.theme.registerStyle("wm-dialog-fill", ai.wagemix.web.components.WMDialogFillStyle)
        ctx.theme.registerStyle("wm-dialog-actions", ai.wagemix.web.components.WMDialogActionsStyle)
        ctx.theme.registerStyle("wm-dialog-button", ai.wagemix.web.components.WMDialogButtonStyle)
        ctx.theme.registerStyle("wm-menu", ai.wagemix.web.components.WMMenuStyle)
        ctx.theme.registerStyle("wm-menu-item", ai.wagemix.web.components.WMMenuItemStyle)
        ctx.theme.registerStyle("wm-menu-dismiss-layer", ai.wagemix.web.components.WMMenuDismissLayerStyle)
        ctx.theme.registerStyle("wm-dropzone", ai.wagemix.web.components.WMDropzoneStyle)
        ctx.theme.registerStyle("wm-dropzone-active", ai.wagemix.web.components.WMDropzoneActiveStyle)
        ctx.theme.registerStyle("wm-upload-row", ai.wagemix.web.components.WMUploadRowStyle)
        ctx.theme.registerStyle("wm-coachmark", ai.wagemix.web.components.WMCoachmarkStyle)
        ctx.theme.registerStyle("wm-coachmark-actions", ai.wagemix.web.components.WMCoachmarkActionsStyle)
        ctx.theme.registerStyle("wm-coachmark-target", ai.wagemix.web.components.WMCoachmarkTargetStyle)
        ctx.theme.registerStyle("wm-coachmark-slot", ai.wagemix.web.components.WMCoachmarkSlotStyle)
        ctx.theme.registerStyle("wm-coachmark-slot-clip", ai.wagemix.web.components.WMCoachmarkSlotClipStyle)
        ctx.theme.registerStyle("wm-coachmark-motion", ai.wagemix.web.components.WMCoachmarkMotionStyle)
        ctx.theme.registerStyle("wm-file-preview-frame", ai.wagemix.web.components.WMFilePreviewFrameStyle)
        ctx.theme.registerStyle("wm-badge", ai.wagemix.web.components.WMBadgeStyle)
        ctx.theme.registerStyle("wm-avatar", ai.wagemix.web.components.WMAvatarStyle)
        ctx.theme.registerStyle("wm-renewal-banner", ai.wagemix.web.components.WMRenewalBannerStyle)
        ctx.theme.registerStyle("wm-icon", ai.wagemix.web.components.WMIconStyle)
        ctx.theme.registerStyle("wm-band-chart-frame", ai.wagemix.web.components.WMBandChartFrameStyle)
        ctx.theme.registerStyle("wm-band-chart-aspect-ratio", ai.wagemix.web.components.WMBandChartAspectRatioStyle)
        ctx.theme.registerStyle("wm-band-chart-frame-content", ai.wagemix.web.components.WMBandChartFrameContentStyle)
        ctx.theme.registerStyle("wm-occupation-row", ai.wagemix.web.components.WMOccupationRowStyle)
        ctx.theme.registerStyle("wm-tree-row", ai.wagemix.web.components.WMTreeRowStyle)
        ctx.theme.registerStyle("wm-tree-row-chevron", ai.wagemix.web.components.WMTreeRowChevronStyle)
        ctx.theme.registerStyle("wm-chart-card-header", ai.wagemix.web.components.WMChartCardHeaderStyle)
        ctx.theme.registerStyle("wm-chart-canvas", ai.wagemix.web.components.WMChartCanvasStyle)
        ctx.theme.registerStyle("wm-card", ai.wagemix.web.components.WMCardStyle)
        ctx.theme.registerStyle("wm-panel", ai.wagemix.web.components.WMPanelStyle)
        ctx.theme.registerStyle("wm-raised", ai.wagemix.web.components.WMRaisedStyle)
        ctx.theme.registerStyle("wm-nav-link", ai.wagemix.web.components.WMNavLinkStyle)
        ctx.theme.registerStyle("wm-nav-link-active", ai.wagemix.web.components.WMNavLinkActiveStyle)
        ctx.theme.registerStyle("wm-marketing-header", ai.wagemix.web.components.WMMarketingHeaderStyle)
        ctx.theme.registerStyle("wm-marketing-header-inner", ai.wagemix.web.components.WMMarketingHeaderInnerStyle)
        ctx.theme.registerStyle("wm-marketing-footer", ai.wagemix.web.components.WMMarketingFooterStyle)
        ctx.theme.registerStyle("wm-marketing-footer-grid", ai.wagemix.web.components.WMMarketingFooterGridStyle)
        ctx.theme.registerStyle("wm-sidebar-item", ai.wagemix.web.components.WMSidebarItemStyle)
        ctx.theme.registerStyle("wm-sidebar-item-label", ai.wagemix.web.components.WMSidebarItemLabelStyle)
        ctx.theme.registerStyle("wm-sidebar-item-active", ai.wagemix.web.components.WMSidebarItemActiveStyle)
        ctx.theme.registerStyle("wm-app-sidebar", ai.wagemix.web.components.WMAppSidebarStyle)
        ctx.theme.registerStyle("wm-sidebar-section-heading", ai.wagemix.web.components.WMSidebarSectionHeadingStyle)
        ctx.theme.registerStyle("wm-app-top-bar", ai.wagemix.web.components.WMAppTopBarStyle)
        ctx.theme.registerStyle("wm-app-top-bar-title", ai.wagemix.web.components.WMAppTopBarTitleStyle)
        ctx.theme.registerStyle("wm-display-text", ai.wagemix.web.theme.WMDisplayTextStyle)
        ctx.theme.registerStyle("wm-page-title-text", ai.wagemix.web.theme.WMPageTitleTextStyle)
        ctx.theme.registerStyle("wm-section-title-text", ai.wagemix.web.theme.WMSectionTitleTextStyle)
        ctx.theme.registerStyle("wm-card-title-text", ai.wagemix.web.theme.WMCardTitleTextStyle)
        ctx.theme.registerStyle("wm-lead-text", ai.wagemix.web.theme.WMLeadTextStyle)
        ctx.theme.registerStyle("wm-body-text", ai.wagemix.web.theme.WMBodyTextStyle)
        ctx.theme.registerStyle("wm-body-strong-text", ai.wagemix.web.theme.WMBodyStrongTextStyle)
        ctx.theme.registerStyle("wm-body-small-text", ai.wagemix.web.theme.WMBodySmallTextStyle)
        ctx.theme.registerStyle("wm-label-text", ai.wagemix.web.theme.WMLabelTextStyle)
        ctx.theme.registerStyle("wm-label-strong-text", ai.wagemix.web.theme.WMLabelStrongTextStyle)
        ctx.theme.registerStyle("wm-caption-text", ai.wagemix.web.theme.WMCaptionTextStyle)
        ctx.theme.registerStyle("wm-overline-text", ai.wagemix.web.theme.WMOverlineTextStyle)
        ctx.theme.registerStyle("wm-stat-text", ai.wagemix.web.theme.WMStatTextStyle)
        ctx.theme.registerStyle("wm-stat-small-text", ai.wagemix.web.theme.WMStatSmallTextStyle)
        ctx.theme.registerStyle("wm-wordmark-text", ai.wagemix.web.theme.WMWordmarkTextStyle)
        ctx.theme.registerStyle("wm-tabular-text", ai.wagemix.web.theme.WMTabularTextStyle)
        ctx.theme.registerStyle("fs-charts-embed-placeholder", com.fsryan.charts.web.components.FSChartsEmbedPlaceholderStyle)
        ctx.theme.registerStyle("fs-wasm-embed", com.fsryan.foundation.web.embed.FSWasmEmbedStyle)
        ctx.theme.registerStyle("fs-alert-dialog", com.fsryan.foundation.web.components.FSAlertDialogStyle)
        ctx.theme.registerStyle("fs-radio-button-option", com.fsryan.foundation.web.components.FSRadioButtonOptionStyle)
        ctx.theme.registerStyle("fs-radio-button", com.fsryan.foundation.web.components.FSRadioButtonStyle)
        ctx.theme.registerStyle("fs-reorderable-item", com.fsryan.foundation.web.components.FSReorderableItemStyle)
        ctx.theme.registerStyle("fs-reorderable-drag-handle", com.fsryan.foundation.web.components.FSReorderableDragHandleStyle)
        ctx.theme.registerStyle("fs-reorderable-column", com.fsryan.foundation.web.components.FSReorderableColumnStyle)
        ctx.theme.registerStyle("fs-reorderable-row", com.fsryan.foundation.web.components.FSReorderableRowStyle)
        ctx.theme.registerStyle("fs-reorderable-grid", com.fsryan.foundation.web.components.FSReorderableGridStyle)
        ctx.theme.registerStyle("fs-linear-discrete-progress-indicator", com.fsryan.foundation.web.components.FSLinearDiscreteProgressIndicatorStyle)
        ctx.theme.registerStyle("fs-linear-discrete-progress-track", com.fsryan.foundation.web.components.FSLinearDiscreteProgressTrackStyle)
        ctx.theme.registerStyle("fs-linear-discrete-progress-fill", com.fsryan.foundation.web.components.FSLinearDiscreteProgressFillStyle)
        ctx.theme.registerStyle("fs-linear-discrete-progress-waypoint", com.fsryan.foundation.web.components.FSLinearDiscreteProgressWaypointStyle)
        ctx.theme.registerStyle("fs-linear-discrete-progress-dot", com.fsryan.foundation.web.components.FSLinearDiscreteProgressDotStyle)
        ctx.theme.registerStyle("fs-linear-discrete-progress-reached-dot", com.fsryan.foundation.web.components.FSLinearDiscreteProgressReachedDotStyle)
        ctx.theme.registerStyle("fs-supporting-text", com.fsryan.foundation.web.components.FSSupportingTextStyle)
        ctx.theme.registerStyle("fs-error-supporting-text", com.fsryan.foundation.web.components.FSErrorSupportingTextStyle)
        ctx.theme.registerStyle("fs-responsive-row", com.fsryan.foundation.web.components.FSResponsiveRowStyle)
        ctx.theme.registerStyle("fs-container", com.fsryan.foundation.web.components.FSContainerStyle)
        ctx.theme.registerStyle("fs-card", com.fsryan.foundation.web.components.FSCardStyle)
        ctx.theme.registerStyle("fs-loading-indicator", com.fsryan.foundation.web.components.FSLoadingIndicatorStyle)
        ctx.theme.registerStyle("fs-loading-scrim", com.fsryan.foundation.web.components.FSLoadingScrimStyle)
        ctx.theme.registerStyle("fs-labeled-text-label", com.fsryan.foundation.web.components.FSLabeledTextLabelStyle)
        ctx.theme.registerStyle("fs-display-large-text", com.fsryan.foundation.web.theme.FSDisplayLargeTextStyle)
        ctx.theme.registerStyle("fs-display-medium-text", com.fsryan.foundation.web.theme.FSDisplayMediumTextStyle)
        ctx.theme.registerStyle("fs-display-small-text", com.fsryan.foundation.web.theme.FSDisplaySmallTextStyle)
        ctx.theme.registerStyle("fs-headline-large-text", com.fsryan.foundation.web.theme.FSHeadlineLargeTextStyle)
        ctx.theme.registerStyle("fs-headline-medium-text", com.fsryan.foundation.web.theme.FSHeadlineMediumTextStyle)
        ctx.theme.registerStyle("fs-headline-small-text", com.fsryan.foundation.web.theme.FSHeadlineSmallTextStyle)
        ctx.theme.registerStyle("fs-title-large-text", com.fsryan.foundation.web.theme.FSTitleLargeTextStyle)
        ctx.theme.registerStyle("fs-title-medium-text", com.fsryan.foundation.web.theme.FSTitleMediumTextStyle)
        ctx.theme.registerStyle("fs-title-small-text", com.fsryan.foundation.web.theme.FSTitleSmallTextStyle)
        ctx.theme.registerStyle("fs-body-large-text", com.fsryan.foundation.web.theme.FSBodyLargeTextStyle)
        ctx.theme.registerStyle("fs-body-medium-text", com.fsryan.foundation.web.theme.FSBodyMediumTextStyle)
        ctx.theme.registerStyle("fs-body-small-text", com.fsryan.foundation.web.theme.FSBodySmallTextStyle)
        ctx.theme.registerStyle("fs-label-large-text", com.fsryan.foundation.web.theme.FSLabelLargeTextStyle)
        ctx.theme.registerStyle("fs-label-medium-text", com.fsryan.foundation.web.theme.FSLabelMediumTextStyle)
        ctx.theme.registerStyle("fs-label-small-text", com.fsryan.foundation.web.theme.FSLabelSmallTextStyle)
        ctx.theme.registerVariant("-wm", ai.wagemix.web.components.WMInputVariant)
        ctx.theme.registerVariant("-wm-info-notice", ai.wagemix.web.components.WMInfoNoticeVariant)
        ctx.theme.registerVariant("-wm-warning-notice", ai.wagemix.web.components.WMWarningNoticeVariant)
        ctx.theme.registerVariant("-wm-error-notice", ai.wagemix.web.components.WMErrorNoticeVariant)
        ctx.theme.registerVariant("-wmai-notice", ai.wagemix.web.components.WMAINoticeVariant)
        ctx.theme.registerVariant("-wm-active-combo-box-option", ai.wagemix.web.components.WMActiveComboBoxOptionVariant)
        ctx.theme.registerVariant("-wm-selected-combo-box-option", ai.wagemix.web.components.WMSelectedComboBoxOptionVariant)
        ctx.theme.registerVariant("-wm-wide-dialog", ai.wagemix.web.components.WMWideDialogVariant)
        ctx.theme.registerVariant("-wm-sheet-dialog", ai.wagemix.web.components.WMSheetDialogVariant)
        ctx.theme.registerVariant("-wm-side-panel-dialog", ai.wagemix.web.components.WMSidePanelDialogVariant)
        ctx.theme.registerVariant("-wm-bottom-sheet-dialog", ai.wagemix.web.components.WMBottomSheetDialogVariant)
        ctx.theme.registerVariant("-wm-destructive-menu-item", ai.wagemix.web.components.WMDestructiveMenuItemVariant)
        ctx.theme.registerVariant("-wm-coachmark-leaving-target", ai.wagemix.web.components.WMCoachmarkLeavingTargetVariant)
        ctx.theme.registerVariant("-wm-closing-coachmark-slot", ai.wagemix.web.components.WMClosingCoachmarkSlotVariant)
        ctx.theme.registerVariant("-wm-leaving-coachmark-motion", ai.wagemix.web.components.WMLeavingCoachmarkMotionVariant)
        ctx.theme.registerVariant("-wm-neutral-badge", ai.wagemix.web.components.WMNeutralBadgeVariant)
        ctx.theme.registerVariant("-wm-primary-badge", ai.wagemix.web.components.WMPrimaryBadgeVariant)
        ctx.theme.registerVariant("-wmai-badge", ai.wagemix.web.components.WMAIBadgeVariant)
        ctx.theme.registerVariant("-wm-warning-badge", ai.wagemix.web.components.WMWarningBadgeVariant)
        ctx.theme.registerVariant("-wm-error-badge", ai.wagemix.web.components.WMErrorBadgeVariant)
        ctx.theme.registerVariant("-wm-success-badge", ai.wagemix.web.components.WMSuccessBadgeVariant)
        ctx.theme.registerVariant("-wm-plan-badge", ai.wagemix.web.components.WMPlanBadgeVariant)
        ctx.theme.registerVariant("-wm-muted-occupation-row", ai.wagemix.web.components.WMMutedOccupationRowVariant)
        ctx.theme.registerVariant("-wm-expanded-tree-row-chevron", ai.wagemix.web.components.WMExpandedTreeRowChevronVariant)
        ctx.theme.registerVariant("-wm-md", ai.wagemix.web.components.WMMdButtonVariant)
        ctx.theme.registerVariant("-wm-sm", ai.wagemix.web.components.WMSmButtonVariant)
        ctx.theme.registerVariant("-wm-secondary", ai.wagemix.web.components.WMSecondaryButtonVariant)
        ctx.theme.registerVariant("-wm-ghost", ai.wagemix.web.components.WMGhostButtonVariant)
        ctx.theme.registerVariant("-wm-ghost-on-primary-container", ai.wagemix.web.components.WMGhostOnPrimaryContainerButtonVariant)
        ctx.theme.registerVariant("-fs-reorderable-column-item", com.fsryan.foundation.web.components.FSReorderableColumnItemVariant)
        ctx.theme.registerVariant("-fs-reorderable-row-item", com.fsryan.foundation.web.components.FSReorderableRowItemVariant)
        ctx.theme.registerVariant("-fs-reorderable-grid-item", com.fsryan.foundation.web.components.FSReorderableGridItemVariant)
        ctx.theme.registerVariant("-fs-reorderable-dragging-item", com.fsryan.foundation.web.components.FSReorderableDraggingItemVariant)
        ctx.theme.registerVariant("-fs-primary", com.fsryan.foundation.web.components.FSPrimaryButtonVariant)
        ctx.theme.registerVariant("-fs-secondary", com.fsryan.foundation.web.components.FSSecondaryButtonVariant)
        ctx.theme.registerVariant("-fs-alert", com.fsryan.foundation.web.components.FSAlertButtonVariant)
        ctx.theme.registerVariant("-fs-deselected", com.fsryan.foundation.web.components.FSDeselectedButtonVariant)
        ctx.theme.registerVariant("-fs-primary-text", com.fsryan.foundation.web.components.FSPrimaryTextButtonVariant)
        ctx.theme.registerVariant("-fs-secondary-text", com.fsryan.foundation.web.components.FSSecondaryTextButtonVariant)
        ctx.theme.registerVariant("-fs-alert-text", com.fsryan.foundation.web.components.FSAlertTextButtonVariant)
        ctx.theme.registerVariant("-fs-deselected-text", com.fsryan.foundation.web.components.FSDeselectedTextButtonVariant)
        ctx.theme.registerVariant("-fs-unoutlined-text", com.fsryan.foundation.web.components.FSUnoutlinedTextButtonVariant)
        ctx.theme.registerVariant("-fs-icon", com.fsryan.foundation.web.components.FSIconButtonVariant)
        ctx.theme.registerVariant("-fs-primary", com.fsryan.foundation.web.components.FSPrimaryLinkVariant)
        ctx.theme.registerVariant("-fs-secondary", com.fsryan.foundation.web.components.FSSecondaryLinkVariant)
        ctx.theme.registerVariant("-fs-alert", com.fsryan.foundation.web.components.FSAlertLinkVariant)
        ctx.theme.registerVariant("-fs-deselected", com.fsryan.foundation.web.components.FSDeselectedLinkVariant)
        ctx.theme.registerKeyframes("wm-side-panel-in", ai.wagemix.web.components.WMSidePanelInKeyframes)
        ctx.theme.registerKeyframes("wm-bottom-sheet-in", ai.wagemix.web.components.WMBottomSheetInKeyframes)
        ctx.theme.registerKeyframes("wm-coachmark-pulse", ai.wagemix.web.components.WMCoachmarkPulseKeyframes)
        ctx.theme.registerKeyframes("wm-coachmark-ring-out", ai.wagemix.web.components.WMCoachmarkRingOutKeyframes)
        ctx.theme.registerKeyframes("wm-coachmark-in", ai.wagemix.web.components.WMCoachmarkInKeyframes)
        ctx.theme.registerKeyframes("wm-coachmark-out", ai.wagemix.web.components.WMCoachmarkOutKeyframes)
        ctx.theme.registerKeyframes("wm-coachmark-open", ai.wagemix.web.components.WMCoachmarkOpenKeyframes)
        ctx.theme.registerKeyframes("wm-coachmark-close", ai.wagemix.web.components.WMCoachmarkCloseKeyframes)
        ctx.theme.registerKeyframes("fs-spin", com.fsryan.foundation.web.components.FSSpinKeyframes)
        ai.wagemix.initWagemixSite(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        ai.wagemix.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
